module.exports = __webpack_public_path__ + "img/sunFlower.56538ba7.jpg";